module.exports = __webpack_public_path__ + "img/2.190b399a.svg";